import { RootState } from "core-integration/src/store";
import { getElementStats } from "core-integration/src/store/element-stats/reducers";
import { IElementStat } from "core-integration/src/store/element-stats/types";
import { getElementTypesById } from "core-integration/src/store/element-types/reducers";
import { IElementTypesById } from "core-integration/src/store/element-types/types";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import {
  IElement,
  IElementEventStats,
  IElementsById,
  IElementsEventDataById,
} from "core-integration/src/store/elements/types";
import { IPickLight } from "core-integration/src/store/entries/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { ITeamsById } from "core-integration/src/store/teams/types";
import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { integerDivide } from "../../utils/points";
import ElementDialogButton from "../ElementDialogButton";
import ElementInTable from "../ElementInTable";
import { ElementRow, ElementTable } from "../ElementTable";
import { ScrollTable } from "../Table";
import Tooltip, { TooltipLabel } from "../Tooltip";
import TeamElementIcon from "./TeamElementIcon";

const EntryEventStatus = styled.th`
  width: 6%;
`;

const EntryEventCpt = styled.th`
  width: 4%;
`;

const EntryEventElement = styled.th`
  width: 32%;
`;

const EntryEventPts = styled.th`
  width: 12%;
`;

interface IEntryEventRowProps {
  chipName: string | null;
  data: IElementEventStats;
  pick: IPickLight;
  element: IElement;
  elementTypesById: IElementTypesById;
  renderElementMenu: (index: number) => void;
  stats: ReadonlyArray<IElementStat>;
  teamsById: ITeamsById;
}

const EntryEventRow: React.FC<IEntryEventRowProps> = ({
  chipName,
  data,
  pick,
  element,
  renderElementMenu,
  stats,
}) => (
  <ElementRow>
    <td>
      <ElementDialogButton elementId={element.id} variant="list" />
    </td>
    <td>
      <TeamElementIcon pick={pick} chipName={chipName} />
    </td>
    <td>
      <ElementInTable
        renderElementMenu={() => renderElementMenu(pick.element)}
        elementId={element.id}
      />
    </td>
    <td>
      {integerDivide(data.total_points * Math.max(pick.multiplier, 1), 10)}
    </td>
    {stats.map((s) => (
      <td key={s.name}>{data[s.name]}</td>
    ))}
  </ElementRow>
);

interface IOwnProps {
  chipName: string | null;
  dataById: IElementsEventDataById | null;
  picks: IPickLight[];
  renderElementMenu: (index: number) => void;
  title: string;
}

interface IPropsFromState {
  elementsById: IElementsById;
  elementTypesById: IElementTypesById;
  stats: ReadonlyArray<IElementStat>;
  teamsById: ITeamsById;
}

type Props = IOwnProps & IPropsFromState;

const EntryEventTable: React.FC<Props> = ({
  dataById,
  elementsById,
  picks,
  stats,
  title,
  ...rest
}) => {
  if (!dataById) {
    return null;
  }
  return (
    <ScrollTable>
      <ElementTable>
        <thead>
          <tr>
            <EntryEventStatus>&nbsp;</EntryEventStatus>
            <EntryEventCpt>&nbsp;</EntryEventCpt>
            <EntryEventElement>{title}</EntryEventElement>
            <EntryEventPts>TP</EntryEventPts>
            {stats.map((s) => (
              <th key={s.name}>
                <Tooltip content={s.label}>
                  <TooltipLabel>
                    {s.label
                      .split(" ")
                      .map((w) => w[0])
                      .join("")
                      .toUpperCase()}
                  </TooltipLabel>
                </Tooltip>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {picks.map((p) => (
            <EntryEventRow
              key={p.element}
              pick={p}
              element={elementsById[p.element]}
              stats={stats}
              data={dataById[p.element].stats}
              {...rest}
            />
          ))}
        </tbody>
      </ElementTable>
    </ScrollTable>
  );
};

const mapStateToProps = (state: RootState): IPropsFromState => {
  return {
    elementsById: getElementsById(state),
    elementTypesById: getElementTypesById(state),
    stats: getElementStats(state),
    teamsById: getTeamsById(state),
  };
};

export default connect(mapStateToProps)(EntryEventTable);
